module.exports = __webpack_public_path__ + "img/buy-notv1.1199eaae.png";